import { render, staticRenderFns } from "./TabFooter.vue?vue&type=template&id=24234dba&scoped=true"
import script from "./TabFooter.vue?vue&type=script&lang=js"
export * from "./TabFooter.vue?vue&type=script&lang=js"
import style0 from "./TabFooter.vue?vue&type=style&index=0&id=24234dba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24234dba",
  null
  
)

export default component.exports